import { useRef, useState } from "react";
import CartButton from "./CartButton";
import MiniCartDialog from "./MiniCartDialog";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import useGetShoppingCart from "@features/unified-user-header-feature/hooks/useGetShoppingCart";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";

export default function ShoppingCart() {
  const [cartOpen, setCartOpen] = useState(false);
  const { hasPermission } = useClaims();
  const cartButtonRef = useRef<HTMLButtonElement>(null);
  const { data: shoppingCartItems, isError } = useGetShoppingCart();

  const canViewShoppingCart = hasPermission(ShiOnePermission.shoppingCartView);

  if (!canViewShoppingCart) return null;

  if (isError) {
    console.error("Failed to load shopping cart items");
    return null;
  }

  return (
    <>
      <CartButton
        cartOpen={cartOpen}
        setCartOpen={setCartOpen}
        ref={cartButtonRef}
        count={shoppingCartItems?.length ?? 0}
      />
      <MiniCartDialog
        open={cartOpen}
        anchorEl={cartButtonRef.current}
        onClose={() => setCartOpen(false)}
      />
    </>
  );
}
